const SignalRMessageOptions = {
	WentToQuote: "WentToQuote"
};

export default SignalRMessageOptions;
